import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Spinner from '../../components/common/Spinner';
import StoresTable from '../../components/blocks/StoresTable';
import UserStoresModal from '../../components/blocks/UserStoresModal';
import { alertError } from '../../store/actions/alert';
import {
  getAdminStores,
  postAdminUserStores,
  deleteAdminUserStores,
  putAdminStores,
  postAdminStores,
  deleteUserStore,
} from '../../store/actions/adminStores';

function StoresTableContainer(props) {
  const { getStores, users } = props;

  const [open, setOpen] = useState(false);
  const [store, setStore] = useState(null);

  useEffect(() => {
    getStores();
  }, [getStores]);

  const openModal = (store) => {
    setStore(store);
    setOpen(true);
  };

  if (props.isLoading) {
    return <Spinner />;
  }

  return (
    <>
      <StoresTable
        openModal={openModal}
        data={props.data}
        save={props.save}
        submitNewStore={props.submitNewStore}
        deleteStore={props.deleteStore}
        alertError={props.alertError}
        users={users}
      />

      <UserStoresModal
        open={open}
        onClose={() => setOpen(false)}
        store={store}
        users={users}
        submit={props.submit}
        deletePermissions={props.deleteStorePermissions}
        updatingUsers={props.updatingUsers}
      />
    </>
  );
}

const mapStateToProps = ({ adminStores }) => {
  const { data, isLoading, users, updatingUsers } = adminStores;

  return {
    data,
    isLoading,
    updatingUsers,
    users,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getStores: () => dispatch(getAdminStores()),
  submit: (storeId, permissions) => dispatch(postAdminUserStores(storeId, permissions)),
  deleteStorePermissions: (storeId, permissions) => dispatch(deleteAdminUserStores(storeId, permissions)),
  save: (storeId, data) => dispatch(putAdminStores(storeId, data)),
  submitNewStore: (data) => dispatch(postAdminStores(data)),
  deleteStore: (storeId) => dispatch(deleteUserStore(storeId)),
  alertError: (error) => dispatch(alertError(error)),
});

export default connect(mapStateToProps, mapDispatchToProps)(StoresTableContainer);

StoresTableContainer.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  getStores: PropTypes.func.isRequired,
  users: PropTypes.arrayOf(PropTypes.object).isRequired,
  submit: PropTypes.func.isRequired,
  deleteStorePermissions: PropTypes.func.isRequired,
  deleteStore: PropTypes.func.isRequired,
};
